module.exports = __webpack_public_path__ + "static/media/m-festival.39aeef16.png";